module.exports = "/shifts/shift-acceptance/shiftAcceptanceNotificationModal-c900dd.html";